define([
  "globals",
  "jquery",
  "local-storage",
  "js-cookie",
  "jquery-history"],
function(globals, $, LocalStorage, Cookies) {

  "use strict";

  $(function() {

    /* Private Variables and Methods */
    var localStorage = new LocalStorage();

    var persistHeightWidth = function() {

      var widthWhole = $("#SelectedWidth").val();
      var widthEigth = $("#SelectedWidthEigth").val();
      var heightWhole = $("#SelectedHeight").val();
      var heightEigth = $("#SelectedHeightEigth").val();

      if (widthEigth == undefined) {
        widthEigth = 0;
      }
      if (heightEigth == undefined) {
        heightEigth = 0;
      }

      var width =  parseFloat(widthWhole) + parseFloat(widthEigth / 8);
      var height = parseFloat(heightWhole) + parseFloat(heightEigth / 8);

      var minWidth = $("#SelectedWidth option:first").val();
      var maxWidth = $("#SelectedWidth option:last").val();

      var minHeight = $("#SelectedHeight option:first").val();
      var maxHeight = $("#SelectedHeight option:last").val();

      var widthStorage = {
        LocalStoragePersister: {},
        minDimension: minWidth,
        maxDimension: maxWidth,
        serializableValue: width,
        getDimensionsEighths: [{ name: "0/0", value: 0 }, { name: "1/8", value: 1 }, { name: "1/4", value: 2 }, { name: "3/8", value: 3 }, { name: "1/2", value: 4 }, { name: "5/8", value: 5 }, { name: "3/4", value: 6 }, { name: "7/8", value: 7 }]
      };
      var heightStorage = {
        LocalStoragePersister: {},
        minDimension: minWidth,
        maxDimension: maxWidth,
        serializableValue: height,
        getDimensionsEighths: [{ name: "0/0", value: 0 }, { name: "1/8", value: 1 }, { name: "1/4", value: 2 }, { name: "3/8", value: 3 }, { name: "1/2", value: 4 }, { name: "5/8", value: 5 }, { name: "3/4", value: 6 }, { name: "7/8", value: 7 }]
      };
      localStorage.persist("SELECTED_WIDTH_STORAGE_KEY", widthStorage);
      localStorage.persist("SELECTED_HEIGHT_STORAGE_KEY", heightStorage);

      Cookies.set("widthz", width);
      Cookies.set("hghtz", height);
    };

    var updateQueryString = function(key, value, url) {
      if (!url) url = window.location.href;
      var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
          hash;

      if (re.test(url)) {
        if (typeof value !== "undefined" && value !== null)
          return url.replace(re, "$1" + key + "=" + value + "$2$3");
        else {
          hash = url.split("#");
          url = hash[0].replace(re, "$1$3").replace(/(&|\?)$/, "");
          if (typeof hash[1] !== "undefined" && hash[1] !== null)
              url += "#" + hash[1];
          return url;
        }
      } else {
        if (typeof value !== "undefined" && value !== null) {
          var separator = url.indexOf("?") !== -1 ? "&" : "?";
          hash = url.split("#");
          url = hash[0] + separator + key + "=" + value;
          if (typeof hash[1] !== "undefined" && hash[1] !== null)
              url += "#" + hash[1];
          return url;
        } else
          return url;
      }
    };

    /* Event Handlers */
    $("body").on("click", ".bdc-searchfilter-choices-list li", function(event) {
      var filterUrl = $(this).find("label > span").attr("data-filter");
      var ajaxUrl = globals.ajaxUrl + filterUrl.substring(filterUrl.indexOf("?"));
      $("#gcc-ab-search-results-loader").removeClass('dn');
      $(".gcc-loading").addClass('db');
      History.pushState({ state: ajaxUrl }, "Blinds Search - " + globals.siteName + " has the products you're looking for!", filterUrl);
      return false;
    });

    $('body').on('click', '.gcc-srch-sort span', function() {
      const sortUrl = $(this).attr('data-filter');
      const ajaxUrl = `${globals.ajaxUrl}${sortUrl.substring(sortUrl.indexOf('?'))}`;
      $("#gcc-ab-search-results-loader").removeClass('dn');
      $(".gcc-loading").addClass('db');
      History.pushState({ state: ajaxUrl }, `Blinds Search - ${globals.siteName} has the products you're looking for!`, sortUrl);
      return false;
    });

    $("body").on("change", "#SelectedWidth, #SelectedWidthEigth, #SelectedHeight, #SelectedHeightEigth", function(event) {
      var widthWhole = $("#SelectedWidth").val();
      var widthEigth = $("#SelectedWidthEigth").val();
      var heightWhole = $("#SelectedHeight").val();
      var heightEigth = $("#SelectedHeightEigth").val();
      if (widthEigth == undefined) {
        widthEigth = 0;
      }
      if (heightEigth == undefined) {
        heightEigth = 0;
      }
      var width = parseFloat(widthWhole) + parseFloat(widthEigth / 8 );
      var height = parseFloat(heightWhole) + parseFloat(heightEigth / 8);
      var url = window.location.href;
      url = updateQueryString("height", height, url);
      url = updateQueryString("width", width, url);
      var ajaxUrl = globals.ajaxUrl + url.substring(url.indexOf("?"));
      $("#gcc-ab-search-results-loader").removeClass('dn');
      $(".gcc-loading").addClass('db');
      History.pushState({ state: ajaxUrl }, "Blinds Search - " + globals.siteName + " has the products you're looking for!", url);
      persistHeightWidth();
    });

    $("body").on("click", "#see-more-products-btn", function(event) {
      var url = $(this).attr("href");
      var ajaxUrl = globals.ajaxUrl + url.substring(url.indexOf("?"));
      $("#gcc-ab-search-results-loader").removeClass('dn');
      $(".gcc-loading").addClass('db');
      History.pushState({ state: ajaxUrl }, "Blinds Search - " + globals.siteName + " has the products you're looking for!", url);
      return false;
    });

    $("body").on("click", ".bdc-productsearch-results-filter", function(event) {
      $(".bdc-searchfilter").addClass("bdc-searchfilter-show");
    });

    $("body").on("click", "#bdc-searchfilter-done", function(event) {
      $(".bdc-searchfilter").removeClass("bdc-searchfilter-show");
      return false;
    });

    $("body").on("change", "#bdc-productsearch-results-sort-items", function(event) {
      var url = window.location.href;
      var sorts = $(this).val();
      var ajaxUrl = globals.ajaxUrl + window.location.search;
      url = updateQueryString("sorts", sorts, url);
      ajaxUrl = updateQueryString("sorts", sorts, ajaxUrl);
      History.pushState({ state: ajaxUrl }, "Blinds Search - " + globals.siteName + " has the products you're looking for!", url);
    });

    History.Adapter.bind(window, "statechange", function() {
      var state = History.getState().data.state || globals.ajaxUrl;
      $(".mt-spinner-wrapper").show();
      $(".bdc-productsearch-results-list").hide();
      $.get(state, {}, function(data) {
        var t = $("body").scrollTop();
        $(".main-content").replaceWith(data);
        $("body").scrollTop(t);
        $(".mt-spinner-wrapper").hide();
      });
    });

    var isMobile = globals.ssm.states[0].active;
    if (isMobile) {
      var ev = globals.isIOS ? "touchstart" : "click";
      $("body").on(ev, function(event) {
        var $elem = $(event.target);
        // Filter Results
        if ($elem.hasClass("gcc-mblsrch-filter") || $elem.hasClass("mt-font-filter")) {
          $( "#bdc-search-filter" ).addClass( "bdc-searchfilter-show" );
        }
      });
    }

    /* Initialization */
    persistHeightWidth();

  });
});
